import { FC, useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import PlayArrow from "@mui/icons-material/PlayArrow";
import { TestimonialType } from "../../../interfaces/testimonial.interface";
import { testimonialCardStyles } from "./testimonial-card.styles";
import { useStyles } from "../../../utils/hooks/useStyles";

export interface TestimonialCardProds {
	testimonial: TestimonialType;
	isVideoPlaying?: boolean;

	onVideoClick?(): void;
}

export const TestimonialCard: FC<TestimonialCardProds> = ({
	testimonial: { name, ageAndJob, testimonial },
	isVideoPlaying,
	onVideoClick,
}) => {
	const styles = useStyles(testimonialCardStyles);
	const videoRef = useRef<HTMLVideoElement>();
	useEffect(() => {
		if (videoRef.current) {
			if (isVideoPlaying) {
				videoRef.current.play();
			} else {
				videoRef.current.pause();
			}
		}
	}, [isVideoPlaying]);

	return (
		<Box>
			<Box sx={styles.card}>
				<Box>
					<Typography sx={styles.nameText}>
						{name}
					</Typography>
					<Typography sx={styles.ageAndJobText}>
						{ageAndJob}
					</Typography>
				</Box>
				{'text' in testimonial && (
					<Typography sx={styles.text}>
						{testimonial.text}
					</Typography>
				)}
				{'videoSrc' in testimonial && (
					<Box
						sx={styles.videoWrapper}
						onClick={onVideoClick}
					>
						<video ref={videoRef} width="100%">
							<source src={testimonial.videoSrc} type="video/webm"/>
						</video>
						{!isVideoPlaying && (
							<Box sx={styles.videoPlayButtonWrapper}>
								<PlayArrow sx={{ width: '50px', height: '50px' }}/>
							</Box>
						)}
					</Box>
				)}
			</Box>
		</Box>
	);
}
